import React from 'react'
import Menu from '../components/Menu'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import getTransitionStyle from '../utils/getTransitionStyle'
import Footer from '../components/Footer'
import Link from '../components/IntlLink'
import PageAnimations from '../components/PageAnimations'
import Img from 'gatsby-image'
import { FormattedMessage } from 'react-intl'

export default class DesignersPage extends React.Component {
  renderDesigner(designer) {
    if (designer.name.toLowerCase() == "wagner") return
    return (
      <div className="designer__page__avatar__container" key={designer.name}>
        <Link className="designer__page__avatar" to={`/designers/${designer.slug}`}>
          <img src={designer.avatar.resize.src} />
          <div className="designer__page__avatar__name">{designer.name}</div>
        </Link>
      </div>
    );
  }

  render() {
    const { data, transition } = this.props;
    const { data: {
        designersPage: { title, description, themeColor, seo, artistsDescription }
      } } = this.props;
    const status = transition ? transition.status : "entering"
    const menuStyle = getTransitionStyle(status, 200, 2000, 'menuStyle')
    const timeout = 800
    const delay = 1000

    const sectionAppears = getTransitionStyle(
      status, timeout, 1000, 'pageAppearsFromBottom'
    )

    const mappedDesigners = data.designers.edges.map(n => n.node)
    const allArtists = mappedDesigners.filter(d => d.isArtist)
    const allDesigners = mappedDesigners.filter(d => !d.isArtist)

    return(
      <div
        className="page"
        style={{ backgroundColor: themeColor.hex }}
      >
        <HelmetDatoCms
          seo={seo}
          favicon={data.site.favicon}
        />

        <Menu
          style={menuStyle}
          hasWhiteLogo={true}
          data={data}
        />

        <PageAnimations
          status={status}
          timeout={timeout}
          delay={timeout}
          color={themeColor.hex}
        />

        <div className="wrap" style={sectionAppears}>
          <h1 className="page__title--white" > {title} </h1>
          <div className="page__textbox">
            <div
              className="page__text"
              dangerouslySetInnerHTML={{ __html: description.markdown.html }}
            />
          </div>
          <div className="designer__page__flex">
            {
              allDesigners.length > 0 &&
                allDesigners.map(designer => this.renderDesigner(designer))
            }
          </div>
          <h2 className="page__title--white" >
            <FormattedMessage id={`designersPage.artists`} />
          </h2>
          <div className="page__textbox">
            <div
              className="page__text"
              dangerouslySetInnerHTML={{ __html: artistsDescription.markdown.html }}
            />
          </div>
          <div className="designer__page__flex">
            {
              allArtists.length > 0 &&
                allArtists.map(designer => this.renderDesigner(designer))
            }
          </div>
        </div>
        <Footer data={data} />
      </div>
    )
  }
}

export const query = graphql`
  query DesignersPage($locale: String!) {
    site: datoCmsSite {
      favicon: faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    designersPage: datoCmsDesignersPage(locale: { eq: $locale }) {
      themeColor {
        hex
      }
      title
      description: descriptionNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      artistsDescription: artistsDescriptionNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }

    designers: allDatoCmsDesigner(filter: { locale: { eq: $locale } }, sort: { fields: [position], order: ASC } ) {
      edges {
        node {
          name
          slug
          isArtist
          avatar {
            resize(width: 300, height: 300, imgixParams: { fm: "jpg", auto: "compress", fit: "crop" }) {
              src
            }
          }
        }
      }
    }

    menuHomepage:           datoCmsHomepage(locale: { eq: $locale })           { menuTitle themeColor { hex } }
    menuInterchangeability: datoCmsInterchangeability(locale: { eq: $locale }) { menuTitle themeColor { hex } slug }
    menuPhilosophy:         datoCmsPhilosophy(locale: { eq: $locale })         { menuTitle themeColor { hex } slug }
    menuAbout:              datoCmsAbout(locale: { eq: $locale })              { menuTitle themeColor { hex } slug }
    menuNews:               datoCmsNewsHome(locale: { eq: $locale })           { menuTitle themeColor { hex } slug }
    menuContact:            datoCmsContact(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuCatalog:            datoCmsCatalog(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuDownload:           datoCmsDownloadArea(locale: { eq: $locale })       { menuTitle themeColor { hex } slug }
    menuDesigners:          datoCmsDesignersPage(locale: { eq: $locale })      { menuTitle themeColor { hex } slug }
    menuFooter:             datoCmsFooter                                      { facebook instagram twitter youtube pinterest companyName address: addressNode { markdown: childMarkdownRemark { html } } googleMapsUrl phoneNumber faxNumber vat emailAddress newsletterTitle newsletterDescription}
  }
`



// WEBPACK FOOTER //
// ./src/templates/designersPage.js